import * as React from 'react';
import { graphql, compose, MutationFn } from 'react-apollo';
import { withRouter, RouteComponentProps, Redirect } from 'react-router-dom';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { connect, DispatchProp } from 'react-redux';

import { ApplicationState } from 'reducers';
import { loginAction } from 'actions/authActions';
import * as Mutations from '@api/graphql/mutations';
import Path from '@utils/Path';
import Env from '@utils/Env';
import { AuthenticationType, AdminProductCategoryList, adminLoginVariables, adminLogin,
    // loginOAuthVariables, loginOAuth, OAuthProvider,
} from '@api/graphql/types';
import Notification from '@components/Notification';
import { getIsAdminByToken } from '@root/utils/Auth';
import GraphQLClient from '@api/graphql/GraphQLClient';
import { updateProductCategoryList } from '@actions/productCategoryActions';
import * as Queries from '@api/graphql/queries';

export interface TokenType {
    is_admin: boolean;
    perimissions: string[];
}

type Props = {
    isLoggedIn: boolean,
    adminLogin: MutationFn<adminLogin, adminLoginVariables>,
    // loginOAuth: MutationFn<loginOAuth, loginOAuthVariables>,
} & RouteComponentProps & InjectedIntlProps & DispatchProp;

interface State {
    email: string;
    password: string;
}

class Login extends React.Component<Props, State> {
    constructor (props: Props) {
        super(props);
        this.state = {
            email: Env.debugUser || '',
            password: Env.debugPassword || '',
        };
    }

    private onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const { email, password } = this.state;
        const { intl } = this.props;

        this.props.adminLogin({
            variables: {email, password, type: AuthenticationType.password},
        })
        .then((response) => {
            if (response && response.data && response.data.adminLogin && response.data.adminLogin.token) {
                if (!getIsAdminByToken(response.data.adminLogin.token)) {
                    throw Error('Non admin user');
                }
            }
            Notification.success(intl.formatMessage({ id: 'page.login.notification.loginSucceed' })).then(() => {
                if (response && response.data && response.data.adminLogin) {
                    this.props.dispatch(loginAction(response.data.adminLogin));
                    GraphQLClient.query<AdminProductCategoryList>({
                        query: Queries.adminProductCategoryList,
                        variables: {parent_id: null},
                    }).then((listResponse) => {
                        if (listResponse.data && listResponse.data.adminProductCategories) {
                            this.props.dispatch(updateProductCategoryList(listResponse.data.adminProductCategories));
                        }
                    });
                }
            });
        }).catch(() => {
            Notification.error(intl.formatMessage({ id: 'page.login.notification.loginFailed' }));
            this.setState({ password: '' });
        });
    }

    public render() {
        // const { intl, location, language } = this.props;
        const { intl, location } = this.props;
        const { from } = location.state || { from: { pathname: Path.dashboard } };

        if (this.props.isLoggedIn) {
            return <Redirect to={from} />;
        }

        const { email, password } = this.state;
        const packageJson = require('../../../package.json');
        return (
            <div className="center full-screen gray-bg">
                <div className="middle-box text-center login-screen animated fadeIn">
                    <div>
                        <div>
                            <img src="/images/groby_logo_black.svg" width="100%" />
                            <h3>{intl.formatMessage({ id: 'page.login.title' })}</h3>
                        </div>

                        <p>&nbsp;</p>

                        <form className="m-t" role="form" onSubmit={this.onSubmit}>
                            <div className="form-group">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder={intl.formatMessage({ id: 'page.login.email' })}
                                    value={email}
                                    onChange={({ currentTarget }) => this.setState({ email: currentTarget.value })}
                                    required={true}
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    type="password"
                                    className="form-control"
                                    placeholder={intl.formatMessage({ id: 'page.login.password' })}
                                    value={password}
                                    onChange={({ currentTarget }) => this.setState({ password: currentTarget.value })}
                                    required={true}/>
                            </div>
                            <button type="submit" className="btn btn-primary block full-width m-b" >
                                {intl.formatMessage({ id: 'page.login.login' })}
                            </button>
                        </form>

                        <p className="m-t">
                            <small>{intl.formatMessage({ id: 'common.copyright' })}</small>
                            <br />
                            <small>{packageJson.version}</small>
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        user: auth.user,
        isLoggedIn: !!auth.user,
    };
};

export default compose(
    graphql<adminLoginVariables, adminLogin, Props>(Mutations.adminLogin, { name: 'adminLogin' }),
    withRouter,
    injectIntl,
    connect(mapStateToProps),
)(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/Login.tsx